export const list_item = {
	group: "list_item",
	content: "paragraph block*",
	defining: true,
};
